import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { cartSlice } from "@src/store/reducers/CartSlice";

const useAutoHideTopDeliveryStatus = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(cartSlice.actions.hideTopDeliveryStatus());
    return () => {
      dispatch(cartSlice.actions.showTopDeliveryStatus());
    };
  }, []);
};

export default useAutoHideTopDeliveryStatus;
